export class TAGPermission {
  name: string = "";
  category: string = "";

  constructor(name: string, category: string) {
    this.name = name;
    this.category = category;
  }

  static fromName(name: string) {
    return this.allPermissions.find((v) => v.name == name);
  }

  // Base
  static pin_login: TAGPermission = new TAGPermission("pin_login", "Base");
  static edit_config: TAGPermission = new TAGPermission("edit_config", "Base");
  static kiosk_mode: TAGPermission = new TAGPermission("kiosk_mode", "Base");

  // OAuth
  static login_wiki: TAGPermission = new TAGPermission("login_wiki", "OAuth");
  static login_cloud: TAGPermission = new TAGPermission("login_cloud", "OAuth");
  static login_mattermost: TAGPermission = new TAGPermission("login_mattermost", "OAuth");

  // Presence
  static view_presence: TAGPermission = new TAGPermission("view_presence", "Presence");
  static create_presence: TAGPermission = new TAGPermission("create_presence", "Presence");
  static edit_presence: TAGPermission = new TAGPermission("edit_presence", "Presence");
  static delete_presence: TAGPermission = new TAGPermission("delete_presence", "Presence");
  static edit_old_presence: TAGPermission = new TAGPermission("edit_old_presence", "Presence");

  // Users
  static view_users: TAGPermission = new TAGPermission("view_users", "Users");
  static create_users: TAGPermission = new TAGPermission("create_users", "Users");
  static edit_users: TAGPermission = new TAGPermission("edit_users", "Users");
  static delete_users: TAGPermission = new TAGPermission("delete_users", "Users");

  // Inventory
  static view_inventory: TAGPermission = new TAGPermission("view_inventory", "Inventory");
  static create_inventory_item: TAGPermission = new TAGPermission("create_inventory_item", "Inventory");
  static edit_inventory_item: TAGPermission = new TAGPermission("edit_inventory_item", "Inventory");
  static delete_inventory_item: TAGPermission = new TAGPermission("delete_inventory_item", "Inventory");

  static inventory_booking: TAGPermission = new TAGPermission("inventory_booking", "Inventory");

  // Finances
  static view_finances: TAGPermission = new TAGPermission("view_finances", "Finances");
  static create_finances: TAGPermission = new TAGPermission("create_finances", "Finances");
  static edit_finances: TAGPermission = new TAGPermission("edit_finances", "Finances");
  static delete_finances: TAGPermission = new TAGPermission("delete_finances", "Finances");

  // Todos
  static view_todos: TAGPermission = new TAGPermission("view_todos", "Todos");
  static create_todos: TAGPermission = new TAGPermission("create_todos", "Todos");
  static edit_todos: TAGPermission = new TAGPermission("edit_todos", "Todos");
  static delete_todos: TAGPermission = new TAGPermission("delete_todos", "Todos");

  // Events
  static create_events: TAGPermission = new TAGPermission("create_events", "Events");
  static edit_events: TAGPermission = new TAGPermission("edit_events", "Events");
  static delete_events: TAGPermission = new TAGPermission("delete_events", "Events");
  static view_events: TAGPermission = new TAGPermission("view_events", "Events");

  // Requests
  static create_requests: TAGPermission = new TAGPermission("create_requests", "Requests");
  static edit_requests: TAGPermission = new TAGPermission("edit_requests", "Requests");
  static delete_requests: TAGPermission = new TAGPermission("delete_requests", "Requests");
  static view_requests: TAGPermission = new TAGPermission("view_requests", "Requests");
  static promote_to_event: TAGPermission = new TAGPermission("promote_to_event", "Requests");

  // Song Requests
  static view_songrequests: TAGPermission = new TAGPermission("view_songrequests", "Song Requests");
  static edit_songrequests: TAGPermission = new TAGPermission("edit_songrequests", "Song Requests");
  static delete_songrequests: TAGPermission = new TAGPermission("delete_songrequests", "Song Requests");

  // Schulradio
  static view_schulradio: TAGPermission = new TAGPermission("view_schulradio", "Schulradio");
  static control_breaks: TAGPermission = new TAGPermission("control_breaks", "Schulradio");
  static control_playback: TAGPermission = new TAGPermission("control_playback", "Schulradio");
  static control_playlist: TAGPermission = new TAGPermission("control_playlist", "Schulradio");
  static control_player: TAGPermission = new TAGPermission("control_player", "Schulradio");

  // Images and Categories
  static create_category: TAGPermission = new TAGPermission("create_category", "Images");
  static view_private_categories: TAGPermission = new TAGPermission("view_private_categories", "Images");
  static edit_category: TAGPermission = new TAGPermission("edit_category", "Images");
  static delete_category: TAGPermission = new TAGPermission("delete_category", "Images");
  static create_image: TAGPermission = new TAGPermission("create_image", "Images");
  static view_private_images: TAGPermission = new TAGPermission("view_private_images", "Images");
  static edit_image: TAGPermission = new TAGPermission("edit_image", "Images");
  static delete_image: TAGPermission = new TAGPermission("delete_image", "Images");

  static allPermissions: TAGPermission[] = [
    // Base
    TAGPermission.pin_login,
    TAGPermission.edit_config,
    TAGPermission.kiosk_mode,

    // OAuth
    TAGPermission.login_wiki,
    TAGPermission.login_cloud,
    TAGPermission.login_mattermost,

    // Presence
    TAGPermission.view_presence,
    TAGPermission.create_presence,
    TAGPermission.edit_presence,
    TAGPermission.delete_presence,
    TAGPermission.edit_old_presence,

    // Users
    TAGPermission.view_users,
    TAGPermission.create_users,
    TAGPermission.edit_users,
    TAGPermission.delete_users,

    // Inventory
    TAGPermission.view_inventory,
    TAGPermission.create_inventory_item,
    TAGPermission.edit_inventory_item,
    TAGPermission.delete_inventory_item,
    TAGPermission.inventory_booking,

    // Finances
    TAGPermission.view_finances,
    TAGPermission.create_finances,
    TAGPermission.edit_finances,
    TAGPermission.delete_finances,

    // Todos
    TAGPermission.view_todos,
    TAGPermission.create_todos,
    TAGPermission.edit_todos,
    TAGPermission.delete_todos,

    // Events
    TAGPermission.create_events,
    TAGPermission.edit_events,
    TAGPermission.delete_events,
    TAGPermission.view_events,

    // Requests
    TAGPermission.create_requests,
    TAGPermission.edit_requests,
    TAGPermission.delete_requests,
    TAGPermission.view_requests,
    TAGPermission.promote_to_event,

    // Song Requests
    TAGPermission.view_songrequests,
    TAGPermission.edit_songrequests,
    TAGPermission.delete_songrequests,

    // Schulradio
    TAGPermission.view_schulradio,
    TAGPermission.control_breaks,
    TAGPermission.control_playback,
    TAGPermission.control_playlist,
    TAGPermission.control_player,

    // Images and Categories
    TAGPermission.create_category,
    TAGPermission.view_private_categories,
    TAGPermission.edit_category,
    TAGPermission.delete_category,
    TAGPermission.create_image,
    TAGPermission.view_private_images,
    TAGPermission.edit_image,
    TAGPermission.delete_image,
  ];
}
